import { render } from "./BankIdForm.vue?vue&type=template&id=855d78b4"
import script from "./BankIdForm.vue?vue&type=script&lang=js"
export * from "./BankIdForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/my-pages-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__